<section [class.white-background]="blockYoutube.whiteBackground" class="block-youtube" data-testid="block-youtube">
    <div class="youtube-video">
        <iframe width="1280" height="720" [src]="iframeUrl" title="" allowfullscreen></iframe>
    </div>
</section>
